import React, { Component } from "react";
import Joi from "joi-browser";
import Input from "./input";
import Select from "./select";
import TextArea from "./textarea";
import CSelect from "./cselect";
import CInput from "./cinput";
import RegSelect from "./reg-select";

class Form extends Component {
  state = {
    data: {},
    errors: {},
  };

  validate = () => {
    const options = { abortEarly: false };
    const { error } = Joi.validate(this.state.data, this.schema, options);

    if (!error) return null;

    const errors = {};
    for (let item of error.details) errors[item.path[0]] = item.message;
    return errors;
  };

  validateProperty = ({ name, value }) => {
    const obj = { [name]: value };
    const schema = { [name]: this.schema[name] };
    const { error } = Joi.validate(obj, schema);

    return error ? error.details[0].message : null;
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const errors = this.validate();
    this.setState({ errors: errors || {} });

    if (errors) return;

    this.doSubmit();
  };

  handleChange = ({ currentTarget: input }) => {
    const errors = { ...this.state.errors };
    const errorMessage = this.validateProperty(input);
    if (errorMessage) errors[input.name] = errorMessage;
    else delete errors[input.name];

    const data = { ...this.state.data };
    data[input.name] = input.value;

    this.setState({ data, errors });
  };

  renderButton(label, disabled = true) {
    return (
      <button
        disabled={disabled ? this.validate() : disabled}
        className="btn btn-invest btn-block"
      >
        {label}
      </button>
    );
  }

  renderControlledSelect(defaultValue, onChange, name, label, options) {
    const { errors } = this.state;

    return (
      <CSelect
        defaultValue={defaultValue}
        onChange={onChange}
        name={name}
        label={label}
        options={options}
        error={errors[name]}
      />
    );
  }

  renderSelect(name, label, options) {
    const { data, errors } = this.state;

    return (
      <Select
        name={name}
        value={data[name]}
        label={label}
        options={options}
        onChange={this.handleChange}
        error={errors[name]}
      />
    );
  }

  renderRegSelect(name, label, options) {
    const { data, errors } = this.state;

    return (
      <RegSelect
        name={name}
        value={data[name]}
        label={label}
        options={options}
        onChange={this.handleChange}
        error={errors[name]}
      />
    );
  }

  renderInput(
    name,
    label,
    placeholder,
    autofocus,
    type = "text",
    value = false
  ) {
    const { data, errors } = this.state;

    return (
      <Input
        name={name}
        value={value ? value : data[name]}
        label={label}
        type={type}
        onChange={this.handleChange}
        error={errors[name]}
        placeholder={placeholder}
        autofocus={autofocus}
      />
    );
  }

  renderControlledInput(
    defaultValue,
    onChange,
    name,
    placeholder,
    label,
    autofocus,
    type = "text"
  ) {
    const { errors } = this.state;

    return (
      <CInput
        defaultValue={defaultValue}
        onChange={onChange}
        name={name}
        placeholder={placeholder}
        autofocus={autofocus}
        label={label}
        type={type}
        error={errors[name]}
      />
    );
  }

  renderTextArea(name, label, rows, type = "text") {
    const { data, errors } = this.state;

    return (
      <TextArea
        name={name}
        value={data[name]}
        label={label}
        rows={rows}
        //defaultValue={defaultValue}
        type={type}
        onChange={this.handleChange}
        error={errors[name]}
      />
    );
  }
}

export default Form;
